import { $t } from '@/i18n';
import SchemaDefault from './xy-modal-schema-default.js';
export default {
  type: 'object',
  fields: [
    {
      id: 'attr',
      title: $t('k_1d95ad3f'),
      type: 'string',
      'uc:allowExpr': false,
      'uc:allowReset': false,
      group: $t('k_1d95ad3f'),
      ui: { type: 'PageletAttr' },
      condition: 'designer.pageletId!=="default"',
    },
    {
      id: 'type',
      title: $t('k_292eff31'),
      type: 'string',
      'uc:allowExpr': false,
      default: SchemaDefault.type,
      group: $t('k_a722db1'),
      enum: [
        { value: 'modal', label: $t('k_6bc5d09c') },
        { value: 'drawer', label: $t('k_1b9d7833') },
        { value: 'adaptation', label: $t('k_6e56fd31') },
      ],
    },
    {
      id: 'drawerPlacement',
      title: $t('k_dcbfb24'),
      type: 'string',
      group: $t('k_a722db1'),
      'uc:allowExpr': false,
      default: SchemaDefault.drawerPlacement,
      enum: [
        { value: 'top', label: $t('k_a0bfb874') },
        { value: 'right', label: $t('k_d373c2f5') },
        { value: 'bottom', label: $t('k_608053e3') },
        { value: 'left', label: $t('k_b74b2d05') },
      ],
      condition: 'props.type === "drawer" || props.type === "adaptation"',
    },
    {
      id: 'width',
      title: $t('k_c9532c0f'),
      type: 'string',
      group: $t('k_a722db1'),
      default: SchemaDefault.width,
      ui: {
        type: 'XyModalSizeEditor',
        unitOptions: [
          { value: 'px', label: 'px' },
          { value: 'vw', label: 'vw' },
          { value: '%', label: '%' },
        ],
      },
      condition: 'props.type === "modal" || props.type === "adaptation" || props.drawerPlacement === "right" || props.drawerPlacement === "left"',
    },
    {
      id: 'height',
      title: $t('k_ee68c4c2'),
      type: 'string',
      group: $t('k_a722db1'),
      default: SchemaDefault.width,
      ui: {
        type: 'XyModalSizeEditor',
        unitOptions: [
          { value: 'px', label: 'px' },
          { value: 'vh', label: 'vh' },
          { value: '%', label: '%' },
        ],
      },
      condition: '(props.type === "drawer" || props.type === "adaptation") && (props.drawerPlacement === "top" || props.drawerPlacement === "bottom")',
    },
    {
      id: 'withTitle',
      title: $t('k_1d29bee4'),
      type: 'boolean',
      group: $t('k_a722db1'),
      'uc:allowExpr': false,
      default: SchemaDefault.withTitle,
    },
    {
      id: 'withFooter',
      title: $t('k_8e8f4d76'),
      type: 'boolean',
      group: $t('k_a722db1'),
      'uc:allowExpr': false,
      default: SchemaDefault.withFooter,
    },
    {
      id: 'isTitleSlot',
      title: $t('k_bbe3cd8b'),
      type: 'boolean',
      group: $t('k_8bdba086'),
      'uc:allowExpr': false,
      default: SchemaDefault.isTitleSlot,
      condition: '!!props.withTitle',
    },
    {
      id: 'title',
      title: $t('k_8bdba086'),
      type: 'string',
      group: $t('k_8bdba086'),
      default: SchemaDefault.title,
      condition: '!props.isTitleSlot && props.withTitle',
    },
    {
      id: 'withClosableIcon',
      title: $t('k_153c239e'),
      type: 'boolean',
      group: $t('k_b78610c4'),
      'uc:allowExpr': false,
      default: SchemaDefault.withClosableIcon,
    },
    {
      id: 'mask',
      title: $t('k_8b0a5d82'),
      type: 'boolean',
      group: $t('k_b78610c4'),
      'uc:allowExpr': false,
      default: SchemaDefault.mask,
    },
    {
      id: 'maskClosable',
      title: $t('k_1825e093'),
      type: 'boolean',
      group: $t('k_b78610c4'),
      'uc:allowExpr': false,
      default: SchemaDefault.maskClosable,
      condition: 'props.mask',
    },
    {
      id: 'keyboard',
      title: $t('k_76157496'),
      type: 'boolean',
      group: $t('k_b78610c4'),
      'uc:allowExpr': false,
      default: SchemaDefault.keyboard,
      condition: 'props.mask',
    },
    {
      id: 'keepAlive',
      title: $t('k_20a11748'),
      type: 'boolean',
      group: $t('k_b78610c4'),
      'uc:allowExpr': false,
      default: SchemaDefault.keepAlive,
      condition: 'designer.pageletId!=="default"',
    },
    {
      id: 'defaultCloseParams',
      type: 'array',
      group: $t('k_2c03fd1c'),
      title: $t('k_552ea40a'),
      ui: {
        type: 'XyPageletPropsEditor',
        props: {
          keyIsInteropable: true,
        },
      },
      items: {
        type: 'object',
        fields: [
          { id: 'key', type: 'string' },
          { id: 'value', type: 'string' },
        ],
      },
    },
  ],
};
